<mat-form-field>
    @if (placeholderKey(); as placeholderKey) {
        <mat-label>{{ placeholderKey | translate }}</mat-label>
    }
    <input
        matInput
        [matDatepicker]="picker"
        [matDatepickerFilter]="datePickerFilter()"
        [formControl]="control() | formControl"
        #inputElement
        [disabled]="isDisabled()"
        [ngStyle]="customStyle()"
        [id]="id()"
        (blur)="onBlur()"
        (input)="onInput($event)" />
    <mat-hint>{{ getHintText() }}</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="picker" />
    <mat-datepicker #picker />
    <mat-error>
        <sl-form-field-error-control [control]="control()" />
    </mat-error>
</mat-form-field>
